module.exports = __webpack_public_path__ + "img/09535_2.prt.cb4dac09.jpg";